var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('div',{attrs:{"id":"player"}}),_c('div',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }